import { render, staticRenderFns } from "./KnowledgeScreen.vue?vue&type=template&id=9a407d18&scoped=true&"
import script from "./KnowledgeScreen.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeScreen.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeScreen.vue?vue&type=style&index=0&id=9a407d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a407d18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
